// UserPostsHeader.tsx
import React from 'react'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

interface UserProfile {
  userId: number
  countryCode: string
  mobileNumber: string
  email: string
  latitude: number
  longitude: number
  gender: 'MALE' | 'FEMALE'
  language: string
  fullName: string
  level: string
  age: number
  bio: string
  profile: string
  location: string
  coverImage: string
  isVerified: number
  badgesId: number
  interest: string // "13,10,9,6,5"
  country: string
  postCount: string
  followers: string
  following: string
}

interface UserPostsHeaderProps {
  activeTab: string
  onTabChange: (tab: string) => void
  profileData?: UserProfile
  baseUrl?: string
  isLoading?: boolean
  onFollowersClick?: () => void  // NEW
  onFollowingClick?: () => void  // NEW
}

const UserPostsHeader: React.FC<UserPostsHeaderProps> = ({
  activeTab,
  onTabChange,
  profileData,
  baseUrl,
  isLoading,
  onFollowersClick,
  onFollowingClick
}) => {
  let t = Tr()

  return (
    <>
      <div className="profile-header">
        <div className="cover-section">
          {isLoading ? (
            <Skeleton height={384} style={{ borderRadius: '0' }} />
          ) : (

            <a
              data-fancybox='gallery'
              className='d-block overlay'
              href={profileData?.coverImage && baseUrl ? baseUrl + profileData?.coverImage : toAbsoluteUrl('/media/logos/mainLogo.png')}
            >
              <div className="cover-section">

                <img
                  src={
                    profileData?.coverImage && baseUrl
                      ? baseUrl + profileData.coverImage
                      : toAbsoluteUrl('/media/logos/mainLogo.png')
                  }
                  alt="Cover"
                  className="cover-image"
                    loading="lazy"
  decoding="async"
                />
              </div>

            </a>
          )}
        </div>

        <div className="profile-picture-wrapper">
          <div className="profile-picture-container">
            {isLoading ? (

              <Skeleton width={150} height={150} className='profile-picture rounded-circle' />
            ) : (
              <a
                data-fancybox='gallery'
                className='d-block overlay'
                href={profileData?.profile && baseUrl ? baseUrl + profileData?.profile : toAbsoluteUrl('/media/logos/mainLogo.png')}
              >
                <img
                  src={profileData?.profile && baseUrl ? baseUrl + profileData?.profile : toAbsoluteUrl('/media/logos/mainLogo.png')}
                  alt="Profile"
                  className="profile-picture rounded-circle"
  loading="lazy"
  decoding="async"
                />
              </a>
            )}

          </div>
        </div>

        <div className="profile-info-section">
          <div className="username-section">
            <h1 className="username">
              {isLoading ? <Skeleton width={200} height={30} /> : profileData?.fullName}
            </h1>
          </div>

          <div className="stats">
            <div className="stat">
              <strong>{isLoading ? <Skeleton width={40} /> : profileData?.postCount}</strong>
              <span>{t('Posts')}</span>
            </div>
            <div className="stat" onClick={onFollowersClick}
            >
              <strong>{isLoading ? <Skeleton width={40} /> : profileData?.followers}</strong>
              <span>{t('Followers')}</span>
            </div>
            <div className="stat" onClick={onFollowingClick}
            >
              <strong>{isLoading ? <Skeleton width={40} /> : profileData?.following}</strong>
              <span>{t('Following')}</span>
            </div>
          </div>

          <p className="bio">
            {isLoading ? <Skeleton count={2} /> : profileData?.bio}
          </p>
        </div>

        {/* TABS */}
        <div className="tabs">
          <button
            className={`tab-btn ${activeTab === 'posts' ? 'active' : ''}`}
            onClick={() => onTabChange('posts')}
            disabled={isLoading}
          >
            {/* <i className="ki-outline ki-element-11 fs-4"></i> */}
            <KTIcon iconName='category' iconType='outline' className={`fs-4 ${activeTab == "posts" ? "text-dark" : "text-muted"}`} />
            <span>{t('Posts')}</span>
          </button>
          <button
            className={`tab-btn ${activeTab === 'about' ? 'active' : ''}`}
            onClick={() => onTabChange('about')}
            disabled={isLoading}
          >
            <KTIcon iconName='information' iconType='outline' className={`fs-4 ${activeTab == "about" ? "text-dark" : "text-muted"}`}  />
            <span>{t('About')}</span>
          </button>
          <button
            className={`tab-btn ${activeTab === 'trips' ? 'active' : ''}`}
            onClick={() => onTabChange('trips')}
            disabled={isLoading}
          >
            <KTIcon iconName='geolocation' iconType='outline' className={`fs-4 ${activeTab == "trips" ? "text-dark" : "text-muted"}`}/>
            <span>{t('Trips')}</span>
          </button>
        </div>
      </div>
    </>
  )
}

export { UserPostsHeader }